module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAABEklEQVRYR2NkGCSAcZC4g2HoOSRh1hODf4x//YkNQab/zBsXpMlcIFY90SESN/thPQMDQwOxBoPULkqVbyRWPdEOITVEGP7837QoU+E81R1CrIHkqsMIEZJ9TqLNuNIOhkPISAskOgV72qF7iOBKO0QnVlK9Tar6oeGQuNkP/4N8tihVniIHE2MOXguwGQDLVeipH5c4yCM0cQhSrkIpOXGJjzoEWx0zGjXote5oiIyGCLSsgLXgMFpmNEkj8PYKWgsMlzjNCjRSa9VRh2ALMZqkkYGKmucMDAwS5FiORc+LRanykrjMItAeeeTPwPB/BhUc84KBgTFjUarcRrIcQqWQIMoYipqARNlApKJRh6AHFACnTzQyBoBTQgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/order/icon-delete-active.png
// module id = 1NV2
// module chunks = 4